const Form016SC = {
    stepName: {
        importantNotes: "重要提示",
        applicationInformation: "申请资料",
        confirmation: "确认",
    },

    importantNotesContent: {
        title: "提示",
        p1: "申请者在递交申报表前，请准备以格式JPG,PNG或PDF的有关文件档案:",
        p1Annotion: "(所有文件的总大小不可超过10MB)",
        p2: "申请者需透过已启用数码签署功能的「智方便」帐户，以办理网上递交申报表。",
        p3: "请将专业发展资料册(附「行动研究计划」)一式两份连同此申请表，经由以下方法递交：",
        p3Point1:
            "以专人递交至香港添马添美道2号政府总部东翼5楼教育局专业发展及培训分部〈请在递交日期最少2个工作天前致电3509 7471登记预约〉；",
        p3Point1BoldText: "或",
        p3Point2:
            "以挂号邮件寄交至香港添马添美道2号政府总部东翼5楼教育局专业发展及培训分部学校领导及专业发展组收",
        iamSignCheck: "本人理解申请人需要拥有「智方便+」帐户才能处理申请。",
    },

    applicationInformationContent: {
        label: {
            refNo: "档案编号：",
            refNoTxtAfterField: "（只供部门使用）",
            circularNumber: "第2/2019号",
            // refNO: "A123",
            formTitle: "个人资料",
            nameOfApplicationEn:
                "申请人姓名（须与申请人之香港身份证上所载相同）（英文）",
            nameOfApplicationCh:
                "申请人姓名（须与申请人之香港身份证上所载相同）（中文）",
            sex: "性別",
            sexOption: {
                male: "男",
                female: "女",
            },
            mailingAddress: "通讯地址（请以英文填写）",
            schoolOrOffice: "电话号码(学校/办公室)",
            schoolOrOfficeOption: {
                school: "学校电话号码",
                office: "办公室电话号码",
            },
            workTel: "电话号码",
            homeOrMobile: "电话号码(住宅/手提)",
            homeOrMobileOption: {
                home: "住宅电话号码",
                mobile: "手提电话号码",
            },
            privateTel: "电话号码",
            fax: "传真号码",
            email: "电邮地址",
            hkidOrPassport: "香港身份证/护照号码",
            hkidOrPassportOption: {
                hkid: "香港身份证",
                passportNo: "护照号码",
            },
            hkid: "香港身份证",
            passportNo: "护照号码",
            rtOrPt: "检定教员/准用教员",
            rtOrPtOption: {
                rtNo: "检定教员",
                ptNo: "准用教员",
            },
            rtNo: "检定教员编号",
            ptNo: "准用教员编号",
            schoolOrOrganisation: "申请人所属学校/机构",
            schoolOrOrganisationOption: {
                school: "申请人所属学校",
                organisation: "申请人所属机构",
            },
            school: "学校",
            organisation: "机构",
            schoolName: "名称",
            schoolAddress: "地址",
            schoolType: "学校类别（如适用）",
            schoolTypeOption: {
                primary: "小学",
                secondary: "中学",
                special: "特殊学校",
            },
            schoolTypeOption2: {
                government: "官立",
                aided: "资助",
                dss: "直资",
                others: "其他",
            },
            otherSchoolType: "其他(請說明)",
            certificationTitle: "专业资历",
            certificationName:
                "师资培训资历(例如教师证书、学位教师教育文凭/证书、教育学士学位或具同等学历)",
            awardingInstituteName: "颁发院校名称",
            awardDate: "颁发日期",
            teachingExperience: "教学年资",
            teachingExperienceOption: {
                five: "五年",
                ten: "六至十年",
                fifteen: "十一至十五年",
                overFifteen: "十五年以上",
            },
            curSchoolOrOrganisation: "在现职学校/机构的职位",
            curSchoolOrOrganisationOption: {
                schoolPost: "学校",
                organisationPost: "机构",
            },
            schoolPost: "在现职学校的职位",
            organisationPost: "在现职机构的职位",
            completeDate: "拟任校长专业发展需要分析完成日期",
            commencementDate: "拟任校长课程开课日期",
            courseAwardDate: "拟任校长课程颁发日期",
            isDeclarationTitle: "声明",
            declarationP1: "谨此声明，",
            // declarationContentList: [
            //     "本人已阅读及明白载于附件甲的「拟任校长专业发展资料册指引」；",
            //     "本人在申请表填写的个人资料，以及就本次申请呈交的专业发展资料册当中的所有事实资料，均属真实准确；",
            //     "本专业发展资料册中所提及的行动研究计划，是本人于就读「拟任校长课程」时进行；以及",
            //     "本专业发展资料册的内容，除引用其他来源资料的部分以外，全属本人作品，而所引用的其他来源资料，其出处已妥为注明，所抄录的部分亦以引文方式标示；本专业发展资料册符合版权法例#。",
            // ],
            declarationP2:
                "本人已阅读及明白载于附件甲的「拟任校长专业发展资料册指引」；",
            declarationP3:
                "本人在申请表填写的个人资料，以及就本次申请呈交的专业发展资料册当中的所有事实资料，均属真实准确；",
            declarationP4:
                "本专业发展资料册中所提及的行动研究计划，是本人于就读「拟任校长课程」时进行；以及",
            declarationP5:
                "本专业发展资料册的内容，除引用其他来源资料的部分以外，全属本人作品，而所引用的其他来源资料，其出处已妥为注明，所抄录的部分亦以引文方式标示；本专业发展资料册符合版权法例",
            //     "本专业发展资料册的内容，除引用其他来源资料的部分以外，全属本人作品，而所引用的其他来源资料，其出处已妥为注明，所抄录的部分亦以引文方式标示；本专业发展资料册符合版权法例#。",
            // ],
            attachment: "附件",
            completedByEDB: "此栏由教育局填写",
        },
        annotation: {
            hash: "请注意，如你的专业发展资料册未能符合版权法例，你的校长资格认证申请可因此被拒。在此情况下，教育局在你最近一次提交申请的日期起计的一年内，不会接受你重新提交的校长资格认证申请；如情况严重，则后果可能更为严峻（如检讨你的教师注册状况）。",
        },
        errorMsg: {
            nameOfApplicationEn: "申请人姓名（英文）",
            nameOfApplicationCh: "申请人姓名（中文）",
            mailingAddress: "通讯地址",
        },
    },
    submittedDialog: {
        note1: "你已成功送出表格。",
        note2: "请将专业发展资料册（附「行动研究计划」）一式两份",
        note3: "连同此申请表",
        note4: "，经由以下方法递交：",
        // note5: "学校发展资料册一式两份",
        note6: "",
        note7: "以专人递交至香港添马添美道2号政府总部东翼5楼教育局专业发展及培训分部〈请在递交日期最少2个工作天前致电3509 7471登记预约〉；或",
        note8: "以挂号邮件寄交至",
        note9: "香港添马添美道2号",
        note10: "政府总部东翼5楼",
        note11: "教育局",
        note12: "专业发展及培训分部",
        note13: "学校领导及专业发展组收",
    },
};
export default Form016SC;
